import { createAsyncThunk } from '@reduxjs/toolkit';
import { canMakePaymentsStrategy } from '../services/applePay/canMakePayments';

export const checkApCanMakePayments = createAsyncThunk<boolean, null, { rejectValue: boolean }>(
  'APPLE_PAY_CAN_MAKE_PAYMENTS',
  () => {
    return canMakePaymentsStrategy();
  },
);
